import { render, staticRenderFns } from "./StudentHeaderModule.vue?vue&type=template&id=5ad7669a&scoped=true"
import script from "./StudentHeaderModule.vue?vue&type=script&lang=js"
export * from "./StudentHeaderModule.vue?vue&type=script&lang=js"
import style0 from "./StudentHeaderModule.vue?vue&type=style&index=0&id=5ad7669a&prod&scoped=true&lang=scss"
import style1 from "./StudentHeaderModule.vue?vue&type=style&index=1&id=5ad7669a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad7669a",
  null
  
)

export default component.exports